import { Box, BoxProps, Heading, HeadingProps } from '@hover/blueprint';
import React, { ReactElement } from 'react';

interface HeaderProps extends BoxProps {
  heading: string;
  subheading: string | ReactElement;
  headingSize?: HeadingProps['size'];
}

const Header = ({
  heading,
  headingSize = 700,
  subheading,
  ...props
}: HeaderProps) => (
  <Box alignItems="center" flexDirection="column" marginBottom={300} {...props}>
    <Heading
      color="neutral700"
      fontWeight="headingLight"
      marginBottom={200}
      marginTop={0}
      size={headingSize}
      textAlign="center"
    >
      {heading}
    </Heading>
    <Heading
      alignSelf="center"
      color="neutral600"
      fontWeight="headingLight"
      marginBottom={0}
      marginTop={0}
      size={200}
      textAlign="center"
    >
      {subheading}
    </Heading>
  </Box>
);

export { Header };
